import { useMutation } from '@tanstack/react-query';

import type {
  BookingStaffBlockMutationResponse,
  CreateBookingStaffBlockData,
  UpdateBookingStaffBlockData,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCreateBookingStaffBlockMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: CreateBookingStaffBlockData }) =>
      HttpClient.request<BookingStaffBlockMutationResponse>({
        method: 'POST',
        url: params.url,
        data: { staff_block: params.data },
      }),
  });

export const useUpdateBookingStaffBlockMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: UpdateBookingStaffBlockData }) =>
      HttpClient.request<BookingStaffBlockMutationResponse>({
        method: 'PUT',
        url: params.url,
        data: { staff_block: params.data },
      }),
  });

export const useDeleteBookingStaffBlockMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<BookingStaffBlockMutationResponse>({
        method: 'DELETE',
        url,
      }),
  });
